import React from 'react';
import { plans } from '../../constant/Data';
import Shape from "../../assets/Background+Border.png"
import { FaCheckCircle } from 'react-icons/fa';
import Master from '../../assets/image 8.png'
import Visa from '../../assets/visa.png'
import American from '../../assets/image 22.png'
import Discover from '../../assets/image 13 (1).png'




const Pricing = () => {
    return (
        <section className=" bg-white space-y-10 pb-20" id='pricing'>
            <div className='bg-[#0E223B] relative p-5 flex items-center flex-col justify-center '>
                <div className='space-y-2 flex items-center flex-col justify-center pb-5'>
                    <h2 className="md:text-xl font-bold text-white">
                        Claim Your Discounted Sinoclear Now                </h2>
                    <p className="text-[#D0DFF2] text-2xl font-semibold">
                        While Supplies Last!                </p>

                </div>

                <img src={Shape} className='w-12 h-12 absolute -bottom-5' />
            </div>
            <div className="max-w-7xl px-6  mx-auto space-y-10">

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
                    {plans && plans.map((plan, index) => (
                        // <div
                        //     key={index}
                        //     className={`rounded-3xl shadow-lg  ${plan.popular ? 'border-4 border-[#0E223B]  bg-white' : 'bg-white border-4 border-white md:mt-10'}`}
                        // >
                        <div
                        key={index}
                        className={`rounded-3xl shadow-lg ${
                            plan.popular
                                ? 'order-1 md:order-none border-4 border-[#0E223B] bg-white'
                                : plan.leastpopular
                                ? 'order-3 md:order-none bg-white border-4 border-white md:mt-10'
                                : 'order-2 md:order-none bg-white border-4 border-white md:mt-10'
                        }`}
                    >
                            <div className="text-center">
                                <div className={` rounded-t-2xl p-4 ${plan.popular ? 'bg-[#0e223b] ' : 'bg-[#D0DFF2] '}`}>
                                    <h3 className={`text-2xl font-semibold ${plan.popular ? 'text-white' : 'text-black'}`}>{plan.title}</h3>
                                    <p className={`text-lg ${plan.popular ? 'text-white' : 'text-black'}`}>{plan.subtitle}</p>

                                </div>
                                <div className="my-3">
                                    <img
                                        src={plan.img}
                                        alt={`${plan.title} Package`}
                                        className={`${plan.popular ? 'lg:w-56 md:w-44 w-40 h-auto' : ' w-40 h-auto '} mx-auto  hover:opacity-90 ease-in-out duration-300 transition`}
                                    />
                                </div>

                                <div className="md:text-6xl border-b  text-4xl font-bold pb-6 gap-1 text-navy-900 flex items-center justify-center w-full">
                                    ${plan.price}
                                    <p className="text-sm text-gray-500  w-14 text-start leading-4 mt-1	uppercase">per bottle</p>
                                </div>
                                {plan.discount && (
                                    <div className=' border-b p-2 gap-1 mb-1 flex items-center w-full justify-center'>
                                        <FaCheckCircle color={`${plan.popular ? '#CB6602' : '#000000'}`} />
                                        <p className={`text-xs font-medium uppercase ${plan.popular ? 'text-[#CB6602]' : 'text-black'}`}>{plan.discount}</p>
                                    </div>
                                )}
                               
                                {plan.biggestdisc && (
                                    <div className=' border-b p-2 gap-1 mb-1 flex items-center w-full justify-center'>
                                        <FaCheckCircle />
                                        <p className={`text-xs font-medium uppercase`}>{plan.biggestdisc}</p>
                                    </div>
                                )}
                                 {plan.gurantee && (
                                    <div className=' border-b p-2 gap-1 mb-1 flex items-center w-full justify-center'>
                                        <FaCheckCircle />
                                        <p className={`text-xs font-medium uppercase`}>{plan.gurantee}</p>
                                    </div>
                                )}
                                {plan.bonuses && (
                                    <div className='gap-1 p-2 mb-1 flex items-center w-full justify-center'>
                                        <FaCheckCircle />
                                        <p className={`text-xs font-medium uppercase`}>{plan.bonuses}</p>
                                    </div>
                                )}
                                <div className='w-full flex items-center justify-center'>

                                    <button
                                     onClick={() => {
      window.open(plan.url, "_blank"); // Opens in a new tab
    }}
                                        className={` ${plan.popular ? 'bg-gradient-to-b from-[#ED6704] to-[#F37A02] text-white border-[#d4742e] hover:bg-gradient-to-b hover:from-[#F37A02] hover:to-[#ED6704] ' : 'bg-gradient-to-b from-[#FCCD15] to-[#FFD814] border-black hover:bg-gradient-to-b hover:from-[#FFD814] hover:to-[#FCCD15]'} w-1/2 border flex items-center justify-center flex-col p-2 rounded-md mb-4 mt-2`}
                                    >
                                        <p className='text-base font-bold leading-3'>
                                            {plan.buttonText}
                                        </p>
                                        <div className="w-fit px-2 rounded-full">
                                            <p className={`text-xs font-semibold leading-5`}>
                                                {plan.buttonTextType}
                                            </p>
                                        </div>
                                    </button>
                                </div>
                                <div className='flex items-center justify-center gap-2'>
                                    <img src={Master} className='w-6' />
                                    <img src={Visa} className='w-6' />
                                    <img src={American} className='w-6' />
                                    <img src={Discover} className='w-6' />

                                </div>
                                <div className='py-2'>
                                    <p>
                                        Total:{" "} <span className='line-through text-sm font-medium text-gray-600'>
                                            ${plan.old_price}
                                        </span>{" "}
                                        <span className='text-sm font-semibold text-black'>${plan.new_price}</span>

                                    </p>
                                    <p
                                        className={`text-base font-semibold ${plan.shipping.toLowerCase() === "free" ? "text-yellow-500" : "text-black"
                                            }`}
                                    >
                                        +  {plan.shipping.toUpperCase()} {" "}

                                        <span className='text-black'>
                                            SHIPPING</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
               
            </div>
        </section>
    );
}

export default Pricing;
